// src/api/associations-api.js
import { gql } from '@apollo/client';
import client from './apollo-client';

// GraphQL Queries
const GET_ASSOCIATIONS = gql`
  query GetAssociations {
    associations {
      id
      nomAssociation
      adresse
      nomContact
      prenomContact
      telContact
      piecesJointes
      evenements {
        id
        date
        location
      }
      createdAt
      updatedAt
    }
  }
`;

const GET_ASSOCIATION = gql`
  query GetAssociation($id: ID!) {
    association(id: $id) {
      id
      nomAssociation
      adresse
      nomContact
      prenomContact
      telContact
      piecesJointes
      evenements {
        id
        date
        location
        conclusions
        laboratory {
          id
          nom
        }
        products {
          id
          name
        }
      }
      createdAt
      updatedAt
    }
  }
`;

const GET_ASSOCIATION_STATS = gql`
  query GetAssociationStats {
    associationStats
  }
`;

// GraphQL Mutations
const CREATE_ASSOCIATION = gql`
  mutation CreateAssociation($createAssociationInput: CreateAssociationInput!) {
    createAssociation(createAssociationInput: $createAssociationInput) {
      id
      nomAssociation
      adresse
      nomContact
      prenomContact
      telContact
      piecesJointes
      createdAt
      updatedAt
    }
  }
`;

const UPDATE_ASSOCIATION = gql`
  mutation UpdateAssociation($updateAssociationInput: UpdateAssociationInput!) {
    updateAssociation(updateAssociationInput: $updateAssociationInput) {
      id
      nomAssociation
      adresse
      nomContact
      prenomContact
      telContact
      piecesJointes
      createdAt
      updatedAt
    }
  }
`;

const DELETE_ASSOCIATION = gql`
  mutation RemoveAssociation($id: ID!) {
    removeAssociation(id: $id)
  }
`;

// Associations API functions
export const associationsApi = {
  getAssociations: async () => {
    try {
      const { data } = await client.query({
        query: GET_ASSOCIATIONS,
        fetchPolicy: 'network-only'
      });
      return data.associations;
    } catch (error) {
      console.error('Get associations error:', error);
      throw error;
    }
  },

  getAssociation: async (id) => {
    try {
      const { data } = await client.query({
        query: GET_ASSOCIATION,
        variables: { id },
        fetchPolicy: 'network-only'
      });
      return data.association;
    } catch (error) {
      console.error(`Get association ${id} error:`, error);
      throw error;
    }
  },

  createAssociation: async (associationData) => {
    try {
      const { data } = await client.mutate({
        mutation: CREATE_ASSOCIATION,
        variables: { createAssociationInput: associationData }
      });
      return data.createAssociation;
    } catch (error) {
      console.error('Create association error:', error);
      throw error;
    }
  },

  updateAssociation: async (associationData) => {
    try {
      const { data } = await client.mutate({
        mutation: UPDATE_ASSOCIATION,
        variables: { updateAssociationInput: associationData }
      });
      return data.updateAssociation;
    } catch (error) {
      console.error(`Update association ${associationData.id} error:`, error);
      throw error;
    }
  },

  removeAssociation: async (id) => {
    try {
      const { data } = await client.mutate({
        mutation: DELETE_ASSOCIATION,
        variables: { id }
      });
      return data.removeAssociation;
    } catch (error) {
      console.error(`Remove association ${id} error:`, error);
      throw error;
    }
  },

  getAssociationStats: async () => {
    try {
      const { data } = await client.query({
        query: GET_ASSOCIATION_STATS,
        fetchPolicy: 'network-only'
      });
      return JSON.parse(data.associationStats);
    } catch (error) {
      console.error('Get association stats error:', error);
      throw error;
    }
  }
};